// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3J0WX","container":"styles_container__1h5VX","title":"styles_title__2SmWc","wrapper":"styles_wrapper__2-Hc3","answer":"styles_answer__2ewg4"};